/*
 * rheincool — Aktionsleiste Merken / Vergleichen / Teilen (Handoff §4)
 *
 * Merken:      localStorage 'rc-merkliste' (Array von Handles), Herz gefüllt.
 * Vergleichen: nutzt denselben Storage wie compare.js ('rc-compare', max 3) —
 *              die Vergleichsleiste auf der PDP zeigt die Auswahl.
 * Teilen:      navigator.share, Fallback Link kopieren mit kurzem Feedback.
 */
class RcProductActions extends HTMLElement {
  connectedCallback() {
    this.handle = this.dataset.handle;
    this.saveBtn = this.querySelector('[data-action-save]');
    this.compareBtn = this.querySelector('[data-action-compare]');
    this.shareBtn = this.querySelector('[data-action-share]');

    if (this.saveBtn) {
      this.syncSave();
      this.saveBtn.addEventListener('click', () => this.toggleSave());
    }
    if (this.compareBtn) {
      this.syncCompare();
      this.compareBtn.addEventListener('click', () => this.toggleCompare());
      window.addEventListener('storage', () => this.syncCompare());
    }
    if (this.shareBtn) {
      this.shareBtn.addEventListener('click', () => this.share());
    }
  }

  readList(key) {
    try {
      return JSON.parse(localStorage.getItem(key)) || [];
    } catch {
      return [];
    }
  }

  toggleSave() {
    let list = this.readList('rc-merkliste');
    if (list.includes(this.handle)) {
      list = list.filter((h) => h !== this.handle);
    } else {
      list.push(this.handle);
    }
    localStorage.setItem('rc-merkliste', JSON.stringify(list));
    this.syncSave();
  }

  syncSave() {
    const saved = this.readList('rc-merkliste').includes(this.handle);
    this.saveBtn.classList.toggle('is-active', saved);
    this.saveBtn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  toggleCompare() {
    // Gleiches Format wie compare.js: [{handle, title}]
    let list = this.readList('rc-compare');
    if (list.some((i) => i.handle === this.handle)) {
      list = list.filter((i) => i.handle !== this.handle);
    } else {
      if (list.length >= 3) list.shift();
      list.push({ handle: this.handle, title: this.dataset.title });
    }
    localStorage.setItem('rc-compare', JSON.stringify(list));
    this.syncCompare();
    // compare.js über die Änderung informieren (gleicher Tab löst kein storage-Event aus)
    document.dispatchEvent(new CustomEvent('rc:compare-change'));
  }

  syncCompare() {
    const active = this.readList('rc-compare').some((i) => i.handle === this.handle);
    this.compareBtn.classList.toggle('is-active', active);
    this.compareBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  async share() {
    const url = this.dataset.url || window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({ title: this.dataset.title, url });
        return;
      } catch {
        return; // Nutzer hat abgebrochen
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      const label = this.shareBtn.querySelector('[data-share-label]');
      if (label) {
        const original = label.textContent;
        label.textContent = this.dataset.copiedText || original;
        setTimeout(() => {
          label.textContent = original;
        }, 1800);
      }
    } catch {
      window.prompt('Link kopieren:', url);
    }
  }
}

customElements.define('rc-product-actions', RcProductActions);
